module.exports = __webpack_public_path__ + "static/media/sign.dfb1b457.png";